// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd1ca478","667":"2783724e","977":"22620874"}[chunkId] + ".chunk.js";
};